import { render, staticRenderFns } from "./AddNewBranchDeposit.vue?vue&type=template&id=2936d300&scoped=true&"
import script from "./AddNewBranchDeposit.vue?vue&type=script&lang=js&"
export * from "./AddNewBranchDeposit.vue?vue&type=script&lang=js&"
import style0 from "./AddNewBranchDeposit.vue?vue&type=style&index=0&id=2936d300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936d300",
  null
  
)

export default component.exports